import {Controller} from "@hotwired/stimulus";
import { callKarrotBridgeSafely } from "../../lib/karrot_bridge_utils";

export default class extends Controller {
    connect() {
      console.log("FeedbackReplies Reload controller connected!")
    callKarrotBridgeSafely((bridge) => {
      bridge.driver.compat.subscribeStream("feedback:cancel", () => {
        window.location.reload(true)
      })
    })
  }
}
